module.exports = __webpack_public_path__ + "img/RS-J-18.165ad022.svg";